export default {
	'stock-quantities': 'Stock Quantities',
	'sample-name': 'Sample Name',
	remaining: 'Remaining',
	'no-samples-to-show': 'NO SAMPLES TO SHOW',
}